import React, { FC } from "react";
import Back from "../common/Back";
import Cart from "../common/Cart";
import MaxWidth from "../styles/max-width";
import styled from "styled-components";
import useShop from "../hooks/use-shop";

interface Props {
  head?: string;
  nameArrow?: string;
  href?: string;
}

const LayoutOrder: FC<Props> = ({
  children,
  head,
  nameArrow,
  href,
  ...props
}) => {
  const { workTimeStart, workTimeEnd, workTimeSet } = useShop();

  return (
    <>
      <MaxWidth {...props}>
        {nameArrow && <Back name={nameArrow} href={href} />}
        <h2>{head}</h2>
        <Main>
          {children}
          <CustomCart
            title="МОЙ ЗАКАЗ"
            description={
              !workTimeSet
                ? `Заказы принимаем с ${workTimeStart} до 24:00`
                : "Заказы принимаем с 8:00 до 24:00"
            }
          />
        </Main>
      </MaxWidth>
    </>
  );
};

const CustomCart = styled(Cart)`
  min-width: 270px;
  max-width: 270px;
  margin-left: 20px;

  @media (max-width: 1020px) {
    display: none;
  }
`;

const Main = styled.div`
  display: flex;
  justify-content: space-between;
  /* overflow: hidden; */
`;

export default LayoutOrder;
